// app/features/news/services_and_hooks/public/useNewsEditionsPublicHook.ts
"use client";

import { useQuery } from '@tanstack/react-query';

import { useAuthStore } from '@/app/auth/services_and_hooks/authStore';

import { newsEditionsPublicService } from './newsEditionsPublicService';

export const useNewsEditionsPublicHook = () => {
  // Get all published editions
  const {
    data: editions,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['public-news-editions'],
    queryFn: () => newsEditionsPublicService.getPublishedEditions(),
  });

  return {
    editions: editions || [],
    isLoading,
    error,
  };
};

export const useNewsEditionDetailHook = (editionDate: string) => {
  const { user } = useAuthStore();

  // Get edition details
  const {
    data: edition,
    isLoading: isLoadingEdition,
    error: editionError,
  } = useQuery({
    queryKey: ['news-edition-detail', editionDate],
    queryFn: () => newsEditionsPublicService.getEditionDetails(editionDate),
    enabled: !!editionDate,
  });

  // Get personalized content if user is authenticated
  const {
    data: personalizedContent,
    isLoading: isLoadingPersonalized,
  } = useQuery({
    queryKey: ['news-edition-personalized', editionDate, user?.id],
    queryFn: () => newsEditionsPublicService.getPersonalizedEdition(editionDate),
    enabled: !!editionDate && !!user,
  });

  return {
    edition,
    personalizedContent,
    isLoading: isLoadingEdition || isLoadingPersonalized,
    error: editionError,
  };
};

export const useNewsStoryDetailHook = (storySlug: string) => {
  const {
    data: story,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['news-story-detail', storySlug],
    queryFn: () => newsEditionsPublicService.getStoryDetails(storySlug),
    enabled: !!storySlug,
  });

  return {
    story,
    isLoading,
    error,
  };
}; 